/* eslint-disable no-nested-ternary */

import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  Skeleton,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import { GetTicketById, UpdateTicketStatusData } from '../../../network/TicketManagement';
import DisplayHelpCenterImageModal from './DisplayHelpCenterImageModal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  flexDirection: 'column',
  minWidth: { xs: '70%', sm: '40%', md: '30%' },
  maxWidth: { xs: '70%', sm: '60%', md: '50%' },
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 2,
  borderRadius: 1,
  maxHeight: '90vh',
  overflowY: 'scroll',
  overflowX: 'hidden'
};

const useStyles = makeStyles({
  textStyle: {
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '18px',
    textAlign: 'left',
    color: '#171D40',
    textWrap: 'nowrap'
  }
});

export default function UpdateTicketStatus({
  openAssignedModal,
  handleClose,
  data,
  setAlertMetas,
  alertMetas,
  onAction
}) {
  const classes = useStyles();

  const [activeStatus, setActiveStatus] = useState(data?.isActive);
  const [selectedTicketData, setSelectedTicketData] = useState(null);
  const [isDisplayImageModal, setIsDisplayImageModal] = useState(false);
  const [displayImage, setDisplayImage] = useState(null);
  const [loader, setLoader] = useState(false);

  const updateStatus = async () => {
    setLoader(true);
    const ticketData = {
      response: 'test',
      isActive: activeStatus
    };
    try {
      const res = await UpdateTicketStatusData(data?.id, ticketData);
      if (res) {
        setLoader(false);
        onAction();
        setAlertMetas({
          ...alertMetas,
          severity: 'success',
          snackBarOpened: true,
          msg: 'Ticket Updated Successfully !!'
        });
      }
    } catch (error) {
      setLoader(false);
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message
      });
    } finally {
      handleClose();
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    }
  };

  const getTicketById = async (id) => {
    try {
      const res = await GetTicketById(id);
      if (res) {
        setSelectedTicketData(res?.data?.data);
      }
    } catch (error) {
      console.log(error, 'error');
    }
  };

  useEffect(() => {
    getTicketById(data?.id);
  }, [data?.id]);

  return (
    <Box>
      <Modal
        open={openAssignedModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid="UpdateTicketSatatusModal"
      >
        <Box
          sx={style}
          style={{ backgroundColor: '#F8FAFB', overflow: 'scroll', overflowX: 'hidden' }}
        >
          {/* <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}> */}
          <Typography sx={{ fontSize: '16px', fontWeight: '800' }}>Update Ticket Status</Typography>
          <Box sx={{ p: 1, overflow: 'scroll', overflowX: 'hidden' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '20px'
              }}
            >
              <Typography className={classes.textStyle} style={{ fontWeight: '700' }}>
                Ticket ID : {selectedTicketData ? selectedTicketData?.id : <Skeleton width={100} />}
              </Typography>
              <Typography className={classes.textStyle} style={{ fontWeight: '700' }}>
                Date :
                {selectedTicketData ? (
                  moment(selectedTicketData?.createdAt, moment.ISO_8601).format('DD/MM/YYYY')
                ) : (
                  <Skeleton width={80} />
                )}
              </Typography>
            </Box>
            <Typography className={classes.textStyle} style={{ fontWeight: '700' }}>
              Device ID :{' '}
              {selectedTicketData ? (
                selectedTicketData?.devices?.[0]?.name
              ) : (
                <Skeleton width={120} />
              )}
            </Typography>
            <Box>
              <Typography
                className={classes.textStyle}
                style={{ marginTop: '20px', fontWeight: '700' }}
              >
                Subject :
              </Typography>
              {selectedTicketData ? (
                <Typography
                  className={classes.textStyle}
                  style={{ textTransform: 'capitalize', marginTop: '10px' }}
                >
                  {selectedTicketData?.title}
                </Typography>
              ) : (
                <Skeleton width="80%" />
              )}
            </Box>
            <Box>
              <Typography
                className={classes.textStyle}
                style={{ marginTop: '20px', fontWeight: '700' }}
              >
                Reason:
              </Typography>
              {selectedTicketData ? (
                <Typography
                  className={classes.textStyle}
                  style={{ marginTop: '10px', textWrap: 'wrap' }}
                >
                  {selectedTicketData?.content}
                </Typography>
              ) : (
                <Skeleton width="90%" />
              )}
            </Box>

            <Box>
              <Typography
                className={classes.textStyle}
                style={{ marginTop: '20px', fontWeight: '700' }}
              >
                Photos/Videos
              </Typography>
              {selectedTicketData ? (
                selectedTicketData?.images?.length > 0 ? (
                  <Box
                    data-testid="images-ticket"
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      overflowX: 'auto',
                      whiteSpace: 'nowrap',
                      gap: 0,
                      mt: 1,
                      p: 1,
                      cursor: 'pointer'
                    }}
                  >
                    {selectedTicketData?.images?.map((image, index) => (
                      <Box
                        key={index}
                        sx={{
                          position: 'relative',
                          width: '50px',
                          height: '50px',
                          flexShrink: 0,
                          margin: '5px'
                        }}
                      >
                        <Button
                          style={{
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            margin: 0,
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            setDisplayImage({ image });
                            setIsDisplayImageModal(true);
                          }}
                        >
                          <img
                            src={image}
                            alt={`Selected ${index + 1}`}
                            style={{
                              width: '50px',
                              height: '50px',
                              objectFit: 'cover',
                              borderRadius: '4px'
                            }}
                            onError={(e) => {
                              e.target.onerror = null; // Prevents infinite loop
                              e.target.src = 'https://via.placeholder.com/50'; // Fallback image
                            }}
                          />
                        </Button>

                        {/* <img
              src={image}
              alt={`Selected ${index + 1}`}
              style={{
                width: '50px',
                height: '50px',
                objectFit: 'cover',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
              onError={(e) => {
                e.target.onerror = null; // Prevents infinite loop
                e.target.src = 'https://via.placeholder.com/50'; // Fallback image
              }}
              onClick={() => {
                setDisplayImage({ image });
                setIsDisplayImageModal(true);
              }}
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  // Adds keyboard accessibility
                  setDisplayImage({ image });
                  setIsDisplayImageModal(true);
                }
              }}
            /> */}
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Typography sx={{ fontSize: '12px', mt: '10px' }}>No Photos Available</Typography>
                )
              ) : (
                <Skeleton width="50%" />
              )}
            </Box>

            {selectedTicketData ? (
              <Box sx={{ display: 'flex', gap: 2, mt: 2, mb: 1 }}>
                <Typography sx={{ fontSize: '12px', mt: 1, fontWeight: '700' }}>Status:</Typography>
                <FormControl sx={{ fontSize: '12px', mt: '2px' }}>
                  <RadioGroup
                    value={activeStatus}
                    name="radio-buttons-group"
                    onChange={(e) => setActiveStatus(e?.target?.value === 'true')}
                  >
                    <FormControlLabel
                      name="isActive"
                      value="true"
                      control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '12px' } }} />}
                      label="Active"
                      sx={{ '& .MuiTypography-root': { fontSize: '12px' } }}
                    />
                    <FormControlLabel
                      name="isActive"
                      value={false}
                      // defaultValue={activeStatus}
                      control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '12px' } }} />}
                      label="Resolved"
                      sx={{ '& .MuiTypography-root': { fontSize: '12px' } }}
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            ) : (
              <Skeleton width="60%" height={50} />
            )}
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'end',
              marginTop: 'auto',
              gap: 2,
              pt: 2
            }}
          >
            <Button variant="outlined" color="primary" size="small" onClick={handleClose}>
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              sx={{ boxShadow: 'none' }}
              onClick={updateStatus}
            >
              Update Data
            </Button>
          </Box>
        </Box>
      </Modal>
      <DisplayHelpCenterImageModal
        openAssignedModal={isDisplayImageModal}
        handleClose={() => setIsDisplayImageModal(false)}
        displayImage={displayImage}
      />
    </Box>
  );
}
